import { useEffect } from "react";
import { CallAdapter, StatefulChatClient } from "@azure/communication-react";

// Dispose of the adapter in the window's before unload event.
// This ensures the service knows the user intentionally left the call if the user
// closed the browser tab during an active call.
export const useDisposeOnPageUnload = (callAdapter?: CallAdapter, chatClient?: StatefulChatClient): void => {

    useEffect(() => {
        const disposeAdapter = (): void => {
            callAdapter?.dispose();
            chatClient?.dispose();
        };

        window.addEventListener('beforeunload', disposeAdapter);
        return () => window.removeEventListener('beforeunload', disposeAdapter);
    }, [callAdapter, chatClient]);
};
